"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostMessageApi = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const usePostMessageApi = (entityID) => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return {
        postMessage: async (payload) => {
            const url = `${config.SHIPPING_ENDPOINT}/activities/reference/${entityID}`;
            await ui_platform_http_1.HttpBaseApi.post(url, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        },
    };
};
exports.usePostMessageApi = usePostMessageApi;
//# sourceMappingURL=postMessageApi.js.map